import type { PortableTextBlock } from 'next-sanity'

const HEADING_LEVELS: Record<string, number> = { h2: 2, h3: 3, h4: 4, h5: 5, h6: 6 }
const FIRST_LEVEL = 2

export type HeadingElement = 'h2' | 'h3' | 'h4' | 'h5' | 'h6'

// Authors pick a heading style for its size, and WordPress posts skip levels (h3 straight after the title,
// h2 followed by h4), which breaks the heading order. Each heading gets the element one level below its
// nearest larger heading (h2 when it has none), so siblings stay siblings. The style, and with it the look,
// is untouched, and a valid sequence comes out unchanged.
export function getHeadingElements(blocks: PortableTextBlock[]): Map<string, HeadingElement> {
  const elements = new Map<string, HeadingElement>()
  const ancestors: { style: number; element: number }[] = []

  for (const block of blocks) {
    const style = HEADING_LEVELS[block.style ?? '']
    if (block._type !== 'block' || !style || !block._key) continue

    while (ancestors.length && ancestors[ancestors.length - 1].style >= style) ancestors.pop()
    const parent = ancestors[ancestors.length - 1]
    const element = Math.min(parent ? parent.element + 1 : FIRST_LEVEL, 6)
    ancestors.push({ style, element })
    elements.set(block._key, `h${element}` as HeadingElement)
  }
  return elements
}
